import { render, staticRenderFns } from "./FollowUpPanel.vue?vue&type=template&id=5563bd28&scoped=true&"
import script from "./FollowUpPanel.vue?vue&type=script&lang=js&"
export * from "./FollowUpPanel.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpPanel.vue?vue&type=style&index=0&id=5563bd28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5563bd28",
  null
  
)

export default component.exports